import { createAsyncThunk } from '@reduxjs/toolkit';

import { IOnboardingUser } from '.';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export interface IUpdateOnboardingUser {
  _id?: string;
  curriculum?: string;
  subject?: string;
  grade?: string;
  subjectExperienceLevel?: string;
  learningStyle?: string;
  upcomingExamStatus?: string;
}

const apiDataProvider = new APIDataProvider();

export const getOnboardingUser = createAsyncThunk(
  '/onboarding/get',
  async (id: string) => {
    const path = `${ApiPaths.onboarding}/${id}`;
    const response = await apiDataProvider.get<TApiResponse<IOnboardingUser>>(
      path
    );

    return response.data;
  }
);

export const updateOnboardingUser = createAsyncThunk(
  '/onboarding/update',
  async (data: IUpdateOnboardingUser) => {
    const path = `${ApiPaths.onboarding}`;
    const response = await apiDataProvider.put<TApiResponse<IOnboardingUser>>(
      path,
      data
    );

    return response.data;
  }
);
